import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

export const loginResetPassSlice = createSlice({
	name: "reset_password",
	initialState: {
		resetPassMessage: "",
		errors: [],
	},

	reducers: {
		getResetPassMessage: (state, action) => {
			state.resetPassMessage = action.payload
            console.log(action.payload,'from reducer');
		},
		getResetPassMessageSuccess: (state, action) => {
			state.resetPassMessage = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
			// console.log(state.errors, 'error form reducer')
			if(state.errors.non_field_errors){
				toast.error(`${state.errors.non_field_errors}`, {
					position: "top-right",
					autoClose: 2000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				})
			}else if(state.errors.password1) {
				toast.error(`${state.errors.password1}`, {
					position: "top-right",
					autoClose: 2000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				})
			}
		},
	},
})

// Action creators are generated for each case reducer function
export const {getResetPassMessage,getResetPassMessageSuccess, getErrors} = loginResetPassSlice.actions

export default loginResetPassSlice.reducer
